enum TopGasAlert {
    NOT_PAYING = 0,
    PAYING = 1,
    PAYING_ESTIMATED = 2,
    PAYING_NOT_IDENTIFIED = 3,
}

//removeIf(production)
export default TopGasAlert;
//endRemoveIf(production)